import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import {
  CreditInformationContainer,
  Banner,
  FormContainer,
  FormData,
  FormDataTitle,
  FormDataGeneral,
  SectionFields,
  StyledButton
} from './createCampaign.styles';
import { environment, url } from 'src/environments';
import ModalAllDataRequired from 'src/components/shared/modals/allDataRequired/allDataRequired';
import ModalErrorAmount from 'src/components/shared/modals/errorAmount/errorAmount';
import { createCampaignSlice } from 'src/store/Campaigns/campaign.slice';
import getCurrentDate from 'src/functions/getCurrentDate';
import { getCurrentDatePlus } from 'src/functions/getCurrentDate';
import ConfirmCampaignModal from 'src/components/shared/modals/CampaignSuccess/campaignSuccess';
import { errorHandler } from 'src/middlewares/Auth/index.utilities';
import { getApplicantFiles, getApplicantPLD, getCreditInfo } from 'src/graphql/customized_queries';

export default function CreateCampaign() {
  const [data, setData] = useState({
    campaignName: '',
    requestedAmount: '',
    loanDestination: '',
    termLoan: '',
    paymentSource: ''
  });
  const [errorAmount, setErrorAmount] = useState(false);
  const [tiie, setTiie] = useState(null);
  const [allDataRequired, setAllDataRequired] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [simafValid, setSimafValid] = useState(null);
  const [filesValidator, setFilesValidator] = useState(null);
  const [tasaInteresAdicionalPorcentaje, setTasaInteresAdicionalPorcentaje] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);

  //JALAR TIIE
  useEffect(() => {
    axios
      .get(`${url}/${environment}/admin/get-tiie`)
      .then((s) => {
        const parsedData = JSON.parse(s.data.body);
        setTiie(Number(parsedData.TIIE));
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getCreditInfo,
          variables: { applicantId: user.id }
        });
        setTasaInteresAdicionalPorcentaje(Number(data.getCreditAnalysis.interestRateApplicant));
      } catch (error) {
        console.error(error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getApplicantFiles,
          variables: { id: user.id }
        });
        const files = data.getFile.areBusinessDocumentsUpload;
        setFilesValidator(files);
      } catch (error) {
        console.error(error);
      }
      try {
        const { data } = await API.graphql({
          query: getApplicantPLD,
          variables: { id: user.id }
        });
        const simaf = data.getApplicant.isPLDApproved;
        setSimafValid(simaf);
      } catch (error) {
        console.error(error);
      }
    };
    fetchUserData();
  }, []);

  //Funciones para validar los inputs para crear campañas y habilitar botón de crear
  const handleData = (e) => {
    setData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  };
  const handleNumber = (e) => {
    let onlyNumber = e.target.value.replace(/[^0-9]/gi, '');
    setData((prevData) => ({
      ...prevData,
      [e.target.name]: onlyNumber
    }));
  };
  const validateFields = () => {
    return (
      data.campaignName &&
      data.requestedAmount &&
      data.termLoan &&
      data.loanDestination &&
      data.paymentSource &&
      filesValidator === true &&
      simafValid === '1'
    );
  };

  const calculateCampaignData = () => {
    const campaignInput = {
      applicantId: user.id,
      montoSolicitado: data.requestedAmount,
      nombreCampania: data.campaignName,
      plazoCredito: data.termLoan,
      destinoCredito: data.loanDestination,
      fuentePago: data.paymentSource,
      createdAt: getCurrentDate(),
      updatedAt: getCurrentDate(),
      dateStartCampaign: getCurrentDate(),
      dateEndCampaign: getCurrentDatePlus(getCurrentDate(), 7),
      tasaInteresAdicionalPorcentaje: tasaInteresAdicionalPorcentaje,
      tasaCreditoPorcentaje: tiie + tasaInteresAdicionalPorcentaje,
      interesCreditoPesos:
        ((tiie + tasaInteresAdicionalPorcentaje) / 360) * data.termLoan * data.requestedAmount,
      IVAinteresCreditoPesos:
        ((tiie + tasaInteresAdicionalPorcentaje) / 360) *
        data.termLoan *
        data.requestedAmount *
        0.16,
      interesesCreditoPesosConIVA:
        ((tiie + tasaInteresAdicionalPorcentaje) / 360) * data.termLoan * data.requestedAmount +
        ((tiie + tasaInteresAdicionalPorcentaje) / 360) *
          data.termLoan *
          data.requestedAmount *
          0.16,
      comisionCreditoPesos: (0.18 / 360) * data.termLoan * data.requestedAmount,
      IVAcomisionCreditoPesos: (0.18 / 360) * data.termLoan * data.requestedAmount * 0.16,
      comisionCreditoPesosConIVA:
        (0.18 / 360) * data.termLoan * data.requestedAmount +
        (0.18 / 360) * data.termLoan * data.requestedAmount * 0.16,
      inversionFinspheraCampaniaPesos: 0.01 * data.requestedAmount,
      tasaInteresMoratorioPorcentaje: (tiie + tasaInteresAdicionalPorcentaje) * 1.5,
      isMoneySent: 0
    };
    return campaignInput;
  };
  const handleCalcs = () => {
    setShowConfirmModal(true);
  };

  const sendDataToServer = async () => {
    const campaignInput = calculateCampaignData();
    try {
      const data = await dispatch(createCampaignSlice(campaignInput));
      navigate(`/solicitante/dashboard/campañas`, {
        state: {
          id: data.payload.createCampaign.id,
          termLoan: campaignInput.termLoan,
          campaignName: campaignInput.campaignName,
          loanDestination: campaignInput.loanDestination,
          paymentSource: campaignInput.paymentSource,
          requestedAmount: campaignInput.requestedAmount,
          dateStartCampaign: campaignInput.dateStartCampaign,
          dateEndCampaign: campaignInput.dateEndCampaign,
          interestRateFinsphera: campaignInput.interestRateFinsphera,
          shareholdingFinsphera: campaignInput.shareholdingFinsphera,
          interestRateInvestor: campaignInput.interestRateInvestor,
          defaultInterestRateInvestor: campaignInput.defaultInterestRateInvestor,
          defaultCommissionInvestor: campaignInput.defaultCommissionInvestor
        }
      });
    } catch (error) {
      console.error(error);
      dispatch(errorHandler);
    }
  };

  const handleConfirmCampaign = () => {
    setShowConfirmModal(false);
    sendDataToServer();
  };

  return (
    <CreditInformationContainer>
      <ModalErrorAmount showModalErrorAmount={errorAmount} setErrorAmount={setErrorAmount} />
      <ModalAllDataRequired
        showModalAllDataRequired={allDataRequired}
        setAllDataRequired={setAllDataRequired}
      />
      <ConfirmCampaignModal
        showModal={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmCampaign}
        campaignData={calculateCampaignData()}
      />
      <Banner>
        <div>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_app_dash_companyInformation_banner.png`}
              alt="icono informacion personal"
            />
          </figure>
          <h2>Crear campaña</h2>
        </div>
      </Banner>
      <FormContainer>
        {filesValidator !== null &&
          simafValid !== null &&
          (filesValidator === false || simafValid === '1' ? (
            <div>
              <h4>
                Aún no has subido tu documentación para poder crear campañas, hazlo:
                <Link to="/solicitante/dashboard/mi-perfil"> aquí</Link>
              </h4>
            </div>
          ) : (
            <></>
          ))}
        <FormData>
          <FormDataTitle>Datos generales de mi campaña:</FormDataTitle>
          <FormDataGeneral>
            <SectionFields>
              <div>
                <p>Nombre de la campaña:</p>
                <input type="text" name="campaignName" onChange={handleData} />
              </div>
              <div>
                <p>¿Cuánto es el crédito que quieres solicitar?</p>
                <input type="text" name="requestedAmount" onChange={handleNumber} />
              </div>
              <div>
                <p>¿En que utilizarás el crédito de esta campaña?</p>
                <select name="loanDestination" onChange={handleData}>
                  <option value={false}>Seleccionar una opción</option>
                  <option value="NOMINA">Pago de nómina</option>
                  <option value="COMPRAS">Compra de Inventario y/o Materia Prima</option>
                  <option value="PROVEEDORES">Pago a proveedores</option>
                  <option value="IMPUESTOS">Pago de impuestos</option>
                  <option value="GASTOS">Pago gastos imprevistos</option>
                  <option value="OTRO">Otro</option>
                </select>
              </div>
            </SectionFields>
            <SectionFields>
              <div>
                <p>Plazo para realizar el pago total de esta campaña (20-190 días):</p>
                <input type="text" name="termLoan" onChange={handleNumber} />
              </div>
              <div>
                <p>Principal fuente de ingresos para el pago de este préstamo:</p>
                <select name="paymentSource" onChange={handleData}>
                  <option value={false}>Seleccionar una opción</option>
                  <option value="VENTAS">Ventas al contado</option>
                  <option value="COBRANZA">Cobranza de ventas a plazo</option>
                  <option value="CREDITO">Disposición de otro crédito</option>
                  <option value="SOCIOS">Nuevas aportaciones de los socios</option>
                  <option value="OTRO">Otro</option>
                </select>
              </div>
            </SectionFields>
          </FormDataGeneral>
        </FormData>
      </FormContainer>
      <StyledButton onClick={handleCalcs} disabled={validateFields()}>
        Crear campaña
      </StyledButton>
    </CreditInformationContainer>
  );
}
